export default "__VITE_ASSET__D$tjAj4e__"